import { render, staticRenderFns } from "./single_report_header.vue?vue&type=template&id=19cfb7b7&scoped=true"
import script from "./single_report_header.vue?vue&type=script&lang=ts"
export * from "./single_report_header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cfb7b7",
  null
  
)

export default component.exports